import { IPartner } from 'common/types';
import { Api } from 'common/utils/api';
import { useQuery } from 'react-query';

export const useListCompanies = () => {
    const result = useQuery(['partners', 'list'], () => Api.get<IPartner[]>({ path: '/partners' }), {
        select(data) {
            if (!data) {
                return [];
            }

            return data
                .filter(partner => partner.category === 'COMPANY')
                .map(company => ({
                    id: company.id,
                    name: company.value,
                }));
        },
    });

    return {
        companies: result.data,
        isLoading: result.isLoading,
        isError: result.isError,
    };
};
